import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, Field, SubmissionError } from 'redux-form'
import { Button } from 'semantic-ui-react'
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { AddBankContainer } from './styled'
import { getBusinessPartners } from 'ducks/options'
import { getBPGeneralView, getBPCompanies } from 'ducks/vendorMaintenance'
// import r from 'reactotron-react-js'

const LoadTypeEModal = (props) => {
  const { valueForm, onLoadMemberSuccess, onLoadMemberWarning, showMemberModal, businessPartners, vendorCompanies } = props

  const submitLoadBusinessPartner = (values) => {
    const { vendorCode, companyCode } = values
    props.getBPGeneralView(vendorCode, companyCode, onLoadMemberSuccess, onLoadMemberWarning)
  }

  React.useEffect(() => {
    if (!businessPartners.data.length && !businessPartners.loading) {
      props.getBusinessPartners()
    }
  }, [])

  const onSelectVendor = (data) => {
    props.getBPCompanies(data)
  }

  const onClickLoadButton = () => {
    const validateResult = validate(valueForm, vendorCompanies)

    if (Object.keys(validateResult).length) {
      throw new SubmissionError(validateResult)
    } else {
      submitLoadBusinessPartner(valueForm)
    }
  }

  const disableLoadButton = () => {
    if (vendorCompanies.loading) {
      return true
    } else {
      if (vendorCompanies.data.length > 0) {
        return (!valueForm.vendorCode || !valueForm.companyCode)
      } else {
        return (!valueForm.vendorCode)
      }
    }
  }

  return (
    <Dialog open={true} className='dialog-full-height' maxWidth='sm' fullWidth style={{ zIndex: 10 }}>
      <DialogTitle>Load Member</DialogTitle>
      <DialogContent>
        <form>
          <AddBankContainer>
            <div className='rowFields'>
              <Field
                name='vendorCode'
                label='Select a member for load default information'
                require
                type={type.select}
                loading={businessPartners.loading}
                options={
                  businessPartners.data.filter(x => 
                    x.value.startsWith('E') && 
                    !x.text.toLowerCase().includes('block') &&
                    !x.text.includes('เงินสดย่อย'))
                  }
                specialOnChange={onSelectVendor}
                component={FieldInput} />
            </div>
            <div className='rowFields'>
              <Field
                name='companyCode'
                label='Company'
                require={
                  vendorCompanies.data.length > 0 && !vendorCompanies.loading
                }
                type={type.select}
                loading={vendorCompanies.loading}
                options={vendorCompanies.data}
                component={FieldInput} />
            </div>
          </AddBankContainer>
        </form>
      </DialogContent>
      <DialogActions>
        <form>
          <Button
            color='blue'
            content='Load'
            disabled={disableLoadButton()}
            type='button'
            onClick={() => onClickLoadButton()}
          />
          <Button
            color='red'
            content='Cancel'
            onClick={() => showMemberModal(false)}
          />
        </form>
      </DialogActions>
    </Dialog>
  )
}

const mapStateToProps = (state, props) => {
  const valueForm = getFormValues('formLoadMember')(state) || {}
  return ({
    valueForm,
    initialValues: {
      vendorCode: valueForm.vendorCode || '',
      companyCode: valueForm.companyCode || '',
    },
    businessPartners: state.options.businessPartners,
    vendorCompanies: state.vendorMaintenance.vendorCompanies
  })
}
  
const mapDispatchToProps = {
  getBusinessPartners,
  getBPGeneralView,
  getBPCompanies,
}

const validate = (values, vendorCompanies) => {
  const errors = {}
  if (!values.vendorCode) errors.vendorCode = 'Require!'

  if (vendorCompanies.data.length > 0 && !values.companyCode) errors.companyCode = 'Require!'

  return errors
}

const LoadVendorForm = reduxForm({
  form: 'formLoadMember',
  enableReinitialize: true
})(LoadTypeEModal)

export default connect(mapStateToProps, mapDispatchToProps)(LoadVendorForm)